<template>
  <page-content
    :has-no-padd-on-act-on-desktop="false"
    :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'"
    :has-right-col-small="true"
    :has-sticky-col-right="true">
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <form
      class="is-12 is-9-widescreen is-8-fullhd is-margin-bottom-xlarge"
      @submit.prevent.stop=""
      v-if="contract && !loading">
      <div class="columns is-gapless is-marginless is-margin-bottom-small has-background-white is-minH64p is-border-top is-border-bottom">
        <div class="is-border-left column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless ">
          <div
            class="column is-narrow is-flex is-padding-small is-margin-right-large is-margin-left-large">
            <span
              class="icon is-self-centered">
              <i class="fa-3x fal fa-folder-open"></i>
            </span>
          </div>
          <div
            class="is-margin-left-large column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
            <span class="is-5 has-text-weight-bold is-uppercase">
              Modèle:
            </span>
            <span class="is-5 is-padding-left-xsmall">
              {{ contract.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- test wysiwyg -->
      <!-- <test-wysiwyg></test-wysiwyg> -->
      <!-- end test -->

      <!-- First section - Page de couverture - home_page_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Page de garde couverture"
        :name="contract.home_page_section.name"
        :mentions="contract.home_page_section.mentions"
        @updateName="val => contract.home_page_section.name = val"
        @addMention="contract.home_page_section.mentions.push({
          is_before: false,
          content: null
        })"
        @updateRadio="val => updateRadio(val, 'home_page_section')"
        @updateComment="val => updateComment(val, 'home_page_section')"
        @deleteMention="val => deleteMention(val, 'home_page_section')">
      </contract-section-bloc>
      <!-- Second section - Rubrique 1 - reservataire_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Rubrique 1"
        :name="contract.reservataire_section.name"
        :mentions="contract.reservataire_section.mentions"
        @updateName="val => contract.reservataire_section.name = val"
        @addMention="contract.reservataire_section.mentions.push({
          is_before: false,
          content: null
        })"
        @updateRadio="val => updateRadio(val, 'reservataire_section')"
        @updateComment="val => updateComment(val, 'reservataire_section')"
        @deleteMention="val => deleteMention(val, 'reservataire_section')">
      </contract-section-bloc>

      <!-- Third section - Rubrique 2 - special_condition_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Rubrique 2"
        :name="contract.special_condition_section.name"
        :hide-mandataries="true"
        :hide-mandataries-data="contract.hide_mandataries_data"
        :fees-section="true"
        :fees-section-content="contract.fees_and_intermediary_commission"
        :mentions="contract.special_condition_section.mentions"
        @updateName="val => contract.special_condition_section.name = val"
        @addMention="contract.special_condition_section.mentions.push({
          is_before: false,
          content: null
        })"
        @updateRadio="val => updateRadio(val, 'special_condition_section')"
        @updateComment="val => updateComment(val, 'special_condition_section')"
        @updateCustomContent="val => contract.fees_and_intermediary_commission[val[0]] = val[1]"
        @deleteMention="val => deleteMention(val, 'special_condition_section')"
        @updateMandataries="val => contract.hide_mandataries_data = val">
      </contract-section-bloc>

      <!-- Fourth section - Rubrique 3 - appel_de_fond_section_custom -->
      <!-- <contract-section-bloc
        class="is-margin-bottom-small"
        v-if="contract.adf_custom_section_activated"
        section-name="Rubrique 3 Appel de fond personnalisé"
        :name="contract.adf_custom_section.name"
        :mentions="contract.adf_custom_section.mentions"
        :hide-page="true"
        :mentions-activated="false"
        @updateName="val => contract.adf_custom_section.name = val"
        @addMention="contract.adf_custom_section.mentions.push({
          is_before: false,
          content: null
        })"
        @hidePage="val => contract.adf_custom_section = val"
        @updateComment="val => updateComment(val, 'adf_custom_section')"
        @deleteMention="val => deleteMention(val, 'adf_custom_section')">
      </contract-section-bloc> -->
      <!-- Fourth section - Rubrique 3 - appel_de_fond_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Rubrique 3"
        :name="contract.appel_de_fond_section.name"
        :mentions="contract.appel_de_fond_section.mentions"
        :hide-page="true"
        :hide-page-data-props="contract.hide_appel_de_fond"
        @updateName="val => contract.appel_de_fond_section.name = val"
        @addMention="contract.appel_de_fond_section.mentions.push({
          is_before: false,
          content: null
        })"
        @hidePage="val => contract.hide_appel_de_fond = val"
        @updateRadio="val => updateRadio(val, 'appel_de_fond_section')"
        @updateComment="val => updateComment(val, 'appel_de_fond_section')"
        @deleteMention="val => deleteMention(val, 'appel_de_fond_section')">
      </contract-section-bloc>
      <div class="column">
        <div class="is-padding-bottom-xsmall">
          <input
            id="hide_adf"
            name="hide_adf"
            v-model="contract.adf_custom_section_activated"
            class="switch is-success is-rounded"
            @change="activeCustomAdf()"
            type="checkbox">
          <label
            for="hide_adf"
            style="font-size: 12.5px"
            class="is-uppercase">Supprimer le texte par défaut de Vadimm</label>
        </div>
      </div>
      <!-- Fifth section - Rubrique 4 - withdrawal_form_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Rubrique 4"
        :name="contract.withdrawal_form_section.name"
        :mentions="contract.withdrawal_form_section.mentions"
        :hide-page="true"
        :hide-page-data-props="contract.hide_withdrawal_form_section"
        @updateName="val => contract.withdrawal_form_section.name = val"
        @addMention="contract.withdrawal_form_section.mentions.push({
          is_before: false,
          content: null
        })"
        @hidePage="val => contract.hide_withdrawal_form_section = val"
        @updateRadio="val => updateRadio(val, 'withdrawal_form_section')"
        @updateComment="val => updateComment(val, 'withdrawal_form_section')"
        @deleteMention="val => deleteMention(val, 'withdrawal_form_section')">
      </contract-section-bloc>

      <!-- sixth section - Rubrique 5 - withdrawal_form_section -->
      <contract-section-bloc
        class="is-margin-bottom-small"
        section-name="Rubrique 5"
        :name="contract.dematerialized_notification.name"
        :notification-section="true"
        :notification-section-content="contract.dematerialized_notification"
        :has-mentions="false"
        @updateCustomContent="val => contract.dematerialized_notification[val[0]] = val[1]"
        @updateName="val => contract.dematerialized_notification.name = val">
      </contract-section-bloc>

      <!-- PAGES -->
      <div>
        <div class="is-padding-left is-padding-right has-background-white is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
          <div class="is-self-centered">
            <span class="is-uppercase title is-6 has-text-weight-normal">Ajouter des pages aux rubriques du modèle vadimm</span>
          </div>
        </div>
        <div class="notification is-warning is-marginless is-minH50p is-flex">
          <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
            Toutes les pages seront ajoutées à la suite du modèle du gabarit vadimm
          </div>
        </div>
        <custom-page-bloc
          class="is-margin-bottom-small"
          v-for="(page, index) in contract.pages"
          :key="index"
          :name="page.name"
          :index="index"
          :content="page.content"
          @deletePage="index => contract.pages.splice(index, 1)"
          @updateContent="val => page.content = val"
          @updateName="val => page.name = val"></custom-page-bloc>
        <div
          class="">
          <button
            @click="contract.pages.push({name:'nouvelle page', content: null})"
            class="button is-fullwidth is-radiusless is-minH75p is-uppercase"
            style="background-color: #5C5C5C; border-color: #5C5C5C; color: #fff">
            <span>Ajouter une page</span>
          </button>
        </div>
      </div>
      <div
        v-if="program || adv"
        class="has-background-white is-margin-top-xsmall">
        <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
          <div
            class="column is-narrow is-flex is-padding-small has-background-success">
            <span
              class="icon is-self-centered has-text-white">
              <i
                class="fas fa-check-circle"></i>
            </span>
          </div>
          <div class="column is-self-centered is-padding-left">
            <div class="title is-4">
              Documents annexés
            </div>
          </div>
        </div>
        <div class="notification is-warning is-marginless is-minH75p is-flex">
          <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
            Tous les documents ci-dessous doivent être téléchargés pour être annexés au contrat de réservation.<br>
            L'icône <span class="icon is-small has-text-success"><i class="fas fa-check-circle"></i></span> signale que
            le fichier téléchargé est correctement lié.
          </div>
        </div>
        <div
          v-for="document in documents"
          :key="document.fus_id"
          class="row-width-actions-bar is-border-bottom">
          <div class="columns is-gapless">
            <div
              class="column is-narrow is-border-right">
              <button class="page-header-btn is-small is-square">
                <span class="icon is-size-4"><i class="fal fa-grip-lines"></i></span>
              </button>
            </div>
            <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
              <div class="column is-narrow">
                <div
                  class="dot is-medium has-text-white is-margin-right-small has-background-success">
                  <i
                    class="fal fa-check is-size-6"></i>
                </div>
              </div>
              <div class="column">
                <span>
                  <a
                    @click="openPreviewDoc(document)"
                    class="is-size-6 is-underline">{{ document.filename }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <template slot="right-col-small">
      <div class="is-padding has-background-white">
        <div>
          <button
            @click="openModalContract(false)"
            type="button"
            class="button is-uppercase is-fullwidth is-success"
            :disabled="submitLoading || disabled"
            :class="[{'is-loading':submitLoading}]">
            <span v-if="!submitLoading">Enregister le modèle</span>
          </button>
        </div>
        <div
          v-if="contractPk"
          class="is-padding-top-xsmall">
          <button
            @click="openModalContract(true)"
            type="button"
            class="button is-uppercase is-fullwidth is-success"
            :disabled="submitLoading || disabled"
            :class="[{'is-loading':submitLoading}]">
            <span v-if="!submitLoading">Enregister comme nouveau</span>
          </button>
        </div>
        <!-- bloquer le bouton de preview si le program n'est pas complet -->
        <div
          class="is-padding-top-xsmall"
          v-if="contract">
          <button
            @click="openPreview()"
            type="button"
            data-tooltip="Données programme incomplètes"
            class="button is-uppercase is-fullwidth is-light"
            :disabled="submitLoading || disabled ||(program && !program.is_valid)"
            :class="[{'is-loading':submitLoading}, {'tooltip is-tooltip-bottom' : program && !program.is_valid}]">
            <span v-if="!submitLoading">Prévisualiser</span>
          </button>
        </div>
      </div>
      <!-- <div class="is-padding is-border-top has-background-white">
        <div class="is-padding-bottom-xsmall">
          <span
            class="is-size-6 has-text-dark has-text-weight-medium">
            Dernière révision
          </span>
        </div>
        <div class="is-padding-bottom-xsmall">
          <span
            class="is-size-6 has-text-dark has-text-weight-bold">
            13/10/2021 14h15
          </span>
          <span
            class="is-size-6 has-text-dark">
            - Modification F.Bravo
          </span>
        </div>
        <div>
          <span
            class="is-size-6 has-text-dark is-underline">
            voir toutes les révisions
          </span>
        </div>
      </div> -->
    </template>
  </page-content>
</template>

<script>

import ContractMixin from './ContractMixin'
import { mapState } from 'vuex'

export default {
  name: 'ContractForm',
  components: {
    ContractSectionBloc: () => import('./ContractSectionBloc'),
    CustomPageBloc: () => import('./CustomPageBloc')
    // TestWysiwyg: () => import('@/components/utils/TestWysiwyg')
  },
  mixins: [ContractMixin],
  props: {
    hideAdf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      submitLoading: false,
      disabled: false,
      boolHideBaseAdf: false,
      hideBaseAdf: false,
      comment: null,
      loadComment: false,
      mentionsAdfCustom: []
    }
  },
  computed: {
    ...mapState(['modal'])
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTRACT_MODAL') {
          if (results[1] === true) {
            this.contract = results[0]
            delete this.contract.pk
            delete this.contract.created_on
            delete this.contract.account
            this.submit(this.contract)
          } else {
            this.contract = results[0]
            this.submit(this.contract)
          }
        }
      }
    }
  },
  methods: {
    submit (contract) {
      if (contract.pk) {
        this.updateContract()
      } else {
        this.createContract()
      }
    },
    /**
    * open preview document
    * @param {object} selectedDocument
    */
    openPreviewDoc (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    deleteMention (index, destination) {
      this.contract[destination].mentions.splice(index, 1)
    },
    updateRadio (args, destination) {
      let value = args[0]
      let idx = args[1]
      this.contract[destination].mentions[idx].is_before = value
    },
    updateComment (args, destination) {
      let value = args[0]
      let idx = args[1]
      this.contract[destination].mentions[idx].content = value
    },
    async activeCustomAdf () {
      let payload = {
        constract: null
      }
      this.contract.adf_custom_section_activated = this.contract.adf_custom_section_activated
      payload['contract'] = this.contract
      this.$emit('addMention')
      if (this.contractPk !== null) {
        let { data } = await this.$api.axios.patch(`custom-contracts/${this.contractPk}`, payload)
        this.contract = data
      }
    },
    patchComment () {
      this.loadComment = true
      // let payload = {
      //   comment: this.comment
      // }
    }
  }
}
</script>
